import { render, staticRenderFns } from "./table-cell.vue?vue&type=template&id=1736236c&scoped=true"
import script from "./table-cell.vue?vue&type=script&lang=js"
export * from "./table-cell.vue?vue&type=script&lang=js"
import style0 from "./table-cell.vue?vue&type=style&index=0&id=1736236c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1736236c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1736236c')) {
      api.createRecord('1736236c', component.options)
    } else {
      api.reload('1736236c', component.options)
    }
    module.hot.accept("./table-cell.vue?vue&type=template&id=1736236c&scoped=true", function () {
      api.rerender('1736236c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/ui/table/table-cell.vue"
export default component.exports